import { css, polished } from 'jimu-core';
import { formValidation } from 'jimu-theme';
export function getInputHeight(inputVarsBySize, inputBorderWidth) {
    const heightInner = polished.math(`
    ${inputVarsBySize.fontSize} * ${inputVarsBySize.lineHeight} +
    ${inputVarsBySize.paddingY} * 2`);
    return inputBorderWidth.toString() === '0'
        ? heightInner
        : `calc(${heightInner} + ${inputBorderWidth} * 2)`;
}
function getInputSizingStyles(inputVars, size) {
    const inputVarsBySize = inputVars.sizes[size];
    return `
    padding: ${inputVarsBySize.paddingY} ${inputVarsBySize.paddingX};
    font-size: ${inputVarsBySize.fontSize};
    line-height: ${inputVarsBySize.lineHeight};
    border-radius: ${inputVarsBySize.borderRadius};
  `;
}
export const textAreaStyles = (props) => {
    var _a;
    const size = props.bsSize || props.size;
    const theme = props.theme;
    const inputVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.input;
    return inputVars && css `
    textarea {
      display: block;
      width: 100%;
      color: ${inputVars.color};
      background-color: ${inputVars.bg};
      background-clip: padding-box;
      border: ${inputVars.border.width} solid ${inputVars.border.color};
      box-shadow: ${inputVars.boxShadow};
      transition: ${inputVars.transition};
      ${!size && getInputSizingStyles(inputVars, 'default')}

      &.is-invalid {
        ${formValidation(false, theme)}
      }

      &::-ms-expand {
        background-color: transparent;
        border: 0;
      }

      &:focus {
        color: ${inputVars.focus.color};
        background-color: ${inputVars.focus.bg};
        outline: 1px solid ${inputVars.focus.borderColor};
        box-shadow: ${inputVars.boxShadow}, ${inputVars.focus.boxShadow};
      }

      /* Placeholder */
      &::placeholder {
        color: ${inputVars.placeHolderColor};
        opacity: 1;
      }

      /* Disabled and read-only inputs */
      &:disabled,
      &[readonly] {
        background: ${inputVars.disabled.bg};
        border-color: ${inputVars.disabled.borderColor};
        opacity: 1;
      }

      &:disabled {
        color: ${inputVars.disabled.color};
        -webkit-text-fill-color: ${inputVars.disabled.color};
      }
    }
  `;
};
